
import { getHomework } from '../../api/homework/index';
import actions from '../actions/index';

export function getHomeworkThunk(data) {
  return (dispatch) => {
    dispatch(actions.homework.startFetching());
    getHomework(data)
      .then(res => {
        if (res.data.info.status) {
          dispatch(actions.homework.getHomeworkTitle(res.data.data));
          dispatch(actions.homework.getHomeworkBlocks(res.data.data.homework_blocks));
        }
      })
      .catch(error => {
        const status = error?.response?.status;
        const message = error?.response?.data?.info?.message;
        dispatch(actions.homework.getHomeworkError(
          message || (status
            ? `Не вдалося завантажити домашнє завдання (помилка ${status}). Спробуйте оновити сторінку.`
            : 'Не вдалося звʼязатися з сервером. Перевірте інтернет і спробуйте ще раз.')
        ));
      })
      .finally(() => dispatch(actions.homework.stopFetching()));
  };
}